<template>
  <div class="wrapContainer">
    <Header :menu-list="menuTop" @doDrop="handleDrop" :title="title"></Header>
    <div class="homeContainer">
      <router-view @setTitle="setTitle"></router-view>
    </div>
    <Footer></Footer>
    <Share :type="'share'"></Share>
  </div>
</template>

<script>
  import Header from '@/components/phone/phoneHead.vue'
  import Footer from '@/components/phone/phoneFoot.vue'
  import Share from '@/components/phone/share.vue'
  import axios from 'axios'
  export default {
    name: "index",
    components: {
      Header,
      Footer,
      Share
    },
    data () {
      return{
        token: '',
        baseurl: 'https://org.api.lotusdata.com/',
        menuList: [],
        menuTop: [],
        title: '陕西省保健学会'
      }
    },
    methods: {
      handleDrop (id) {
        let self = this;
        self.menuTop.forEach((item, index) => {
          if (item.id == id) {
            item.expand = !item.expand
          }
        })
      },
      setTitle (e) {
        this.title = e;
      },
      setTopMenu() {
        let self = this;
        self.menuList.forEach((item, index) => {
          if (item.top === "1") {
            self.menuTop.push({
              title: item.title,
              pid: item.pid,
              id: item.id,
              top: item.top,
              expand: false,
              children: item.children,
              dtype: item.dtype,
              Showstyle: item.Showstyle,
              newslink: item.newslink
            });
          }
        });
      },
      filterData(data) {
        let self = this;
        self.menuList.forEach((child, index) => {
          data.filter((item) => {
            if (item.Pid == child.id) {
              if (item.Top === "1") {
                self.menuList[index].children.push({
                  title: item.Name,
                  pid: item.Pid,
                  id: item.Id,
                  top: item.Top,
                  dtype: item.DType,
                  Showstyle: item.Showstyle,
                  newslink: item.NewsLink
                });
              }
            }
          });
        });
        self.setTopMenu();
      },
      filterParent(data) {
        let self = this;
        var id = "";
        var temp = [];
        data.filter((item) => {
          if (item.Pid == "") {
            id = item.Id;
          }
        });
        data.filter((item) => {
          if (item.Pid == id) {
            temp.push({
              title: item.Name,
              pid: item.Pid,
              id: item.Id,
              order: item.Orderindex,
              index: parseInt(item.Orderindex),
              top: item.Top,
              children: [],
            });
          }
        });
        for (let i = 0; i < temp.length; i++) {
          for (let j = i + 1; j < temp.length; j++) {
            if (temp[j].index < temp[i].index) {
              var middle = temp[i];
              temp[i] = temp[j];
              temp[j] = middle;
            }
          }
        }
        self.menuList = temp;
        self.filterData(data);
      },
      getmenuList () {
        let self = this;
        axios.get(this.baseurl + "operations/v1/column/list?offset=0&limit=1000",{
          headers: {'Authorization': this.token}
        }).then(
          function (res) {
            if(res.data.code == "0"){
              var data = res.data.data;
              self.filterParent(data);
            }
          },function (err) {
            self.$Message.error(err);
          }
        )
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.token = localStorage.getItem('token');
        this.getmenuList()
      })
    }
  }
</script>

<style lang="less" scoped>
  @baseBase: #eaf0eb;
  @base: #3e8f83;

  .wrapContainer{
    width:100%;
    display: block;
    height: auto;
  }
  .homeContainer{
    width:92%;
    height: auto;
    margin: 0.2rem 4%;
    margin-top: 1.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/phoneHome/main.vue